<app-mat-spinner-overlay *ngIf="loading"></app-mat-spinner-overlay>
<div class="dropdown">
  <button class="mt-2 btn font-size-12 button-btn dropdown-toggle mat-button-wrapper" style="padding: 0.625rem"
    type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
    Generate {{ textName }}
  </button>
  <div class="dropdown-menu shadow-sm" aria-labelledby="dropdownMenuButton"
    style="max-height: 15rem; min-width: max-content; overflow-y: auto; z-index: 1050">
    <a class="dropdown-item" *ngFor="let x of dropdownLanguages" (click)="Get_Template(x.Id)">{{ x.Template_Name }}</a>
  </div>
</div>

<div class="modal fade in" id="Template{{ TemplateName }}model" tabindex="-1" role="dialog"
  aria-labelledby="myModalLabel" data-backdrop="false" style="background-color: rgba(0, 0, 0, 0.5); overflow: auto">
  <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
    <div cdkDrag cdkDragRootElement=".cdk-overlay-pane" class="modal-content">
      <div cdkDragHandle class="modal-header" style="padding: 0.625rem">
        <button type="button" class="font-size-12 button-btn" color="primary" [class.spinner]="loading"
          (click)="printLetter()">
          Print {{ textName }}
        </button>
        <button type="button" (click)="OnClose()" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">
            <i class="far text-black fa-times-circle"></i>
          </span>
        </button>
      </div>
      <div class="modal-body" id="pdf{{ TemplateName }}LetterDownload" style="overflow-wrap: anywhere">
        <div class="row mb-0">
          <div class="col-md-12 ck-content">
            <div [innerHtml]="content"></div>
          </div>
        </div>
      </div>

      <div id="LODPrint" style="display: none">
        <table class="MsoTableGrid" width="62.5rem" border="1" cellspacing="0" cellpadding="0">
          <thead>
            <tr>
              <!--<th class="WD-66">Document Type</th>-->
              <th class="WD-66">Document Title</th>
              <th class="WD-66">In Favour Of</th>
              <th class="WD-66">Date Of Executation</th>
              <th class="WD-66">Executation By</th>
              <th class="WD-66">No Of Pages</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let data of LODData; let i = index">
              <!--<td>{{ data.DocType }}</td>-->
              <td>{{ data.DocTitle }}</td>
              <td>{{ data.Remark }}</td>
              <td>{{ data.DateOfExecution }}</td>
              <td>{{ data.ExecutedBy }}</td>
              <td>{{ data.No_Of_Pages }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div id="sanctionDetailPrintAgreement" style="display: none">
        <table style="font-size: 0.9375rem" class="MsoTableGrid" width="100%" border="1" cellspacing="0"
          cellpadding="0">
          <thead>
            <tr class="height-sanctionDetail" style="background-color: #acc8ee">
              <!--<th class="WD-66">Document Type</th>-->
              <th class="WD-66" style="padding-left: 0.625rem">Sr.No.</th>
              <th class="WD-66" style="padding-left: 0.625rem">Parameter</th>
              <th class="WD-66" style="padding-left: 0.625rem">Details</th>
            </tr>
          </thead>
          <tbody>
            <tr class="height-sanctionDetail">
              <td style="text-align: center">1</td>
              <td style="text-align: left; padding-left: 0.625rem">
                Sanctioned Loan Amount
              </td>
              <td style="text-align: right; padding-right: 0.625rem">
                {{ sanctionLoanAmountObj?.sanction_LoanAmount }}
              </td>
            </tr>
            <tr class="height-sanctionDetail">
              <td style="text-align: center">2</td>
              <td style="text-align: left; padding-left: 0.625rem">
                Deduction - Processing Fees &#64;
                {{ sanctionLoanAmountObj?.ProcessingFeePercentage }} %
              </td>
              <td style="text-align: right; padding-right: 0.625rem">
                {{ sanctionLoanAmountObj?.ProcessingFeeCharges }}
              </td>
            </tr>

            <tr class="height-sanctionDetail">
              <td style="text-align: center">3</td>
              <td style="text-align: left; padding-left: 0.625rem">
                Deduction - KYC Verification
              </td>
              <td style="text-align: right; padding-right: 0.625rem">
                {{ sanctionLoanAmountObj?.Kyc_Charges }}
              </td>
            </tr>

            <tr class="height-sanctionDetail">
              <td style="text-align: center">4</td>
              <td style="text-align: left; padding-left: 0.625rem">
                Deduction - On Boarding Fee
              </td>
              <td style="text-align: right; padding-right: 0.625rem">
                {{ sanctionLoanAmountObj?.OnBoarding_Charges }}
              </td>
            </tr>
            <tr class="height-sanctionDetail">
              <td style="text-align: center">5</td>
              <td style="text-align: left; padding-left: 0.625rem">
                GST &#64; 18% on Deduction
              </td>
              <td style="text-align: right; padding-right: 0.625rem">
                {{ sanctionLoanAmountObj?.Gst_OnDeduction }}
              </td>
            </tr>
            <tr class="height-sanctionDetail">
              <td style="text-align: center">6</td>
              <td style="text-align: left; padding-left: 0.625rem">
                Total Deductible Amount:
              </td>
              <td style="text-align: right; padding-right: 0.625rem">
                {{ sanctionLoanAmountObj?.Total_Deduction }}
              </td>
            </tr>

            <tr class="height-sanctionDetail">
              <td style="text-align: center">7</td>
              <td style="text-align: left; padding-left: 0.625rem">
                Net Disbursement Amount :
              </td>
              <td style="text-align: right; padding-right: 0.625rem">
                {{ sanctionLoanAmountObj?.NetDisbursementAmount }}
              </td>
            </tr>

            <tr class="height-sanctionDetail">
              <td style="text-align: center">8</td>
              <td style="text-align: left; padding-left: 0.625rem">
                Sanction Interest Amount:
              </td>
              <td style="text-align: right; padding-right: 0.625rem">
                {{ sanctionLoanAmountObj?.Sanction_InterestAmount }}
              </td>
            </tr>

            <tr class="height-sanctionDetail">
              <td style="text-align: center">9</td>
              <td style="text-align: left; padding-left: 0.625rem">
                Total Amount to be paid by By Borrower:
              </td>
              <td style="text-align: right; padding-right: 0.625rem">
                {{ sanctionLoanAmountObj?.PaidByBorrower }}
              </td>
            </tr>
          </tbody>
        </table>

        <table style="font-size: 0.9375rem" class="MsoTableGrid" width="100%" border="1" cellspacing="0"
          cellpadding="0">
          <thead>
            <tr class="height-sanctionDetail">
              <!--<th class="WD-66">Document Type</th>-->
              <th class="WD-66" colspan="3" style="text-align: center">
                Interest Calculation
              </th>
            </tr>
          </thead>
          <tbody>
            <tr class="height-sanctionDetail">
              <td style="text-align: center; width: 11%">1</td>
              <td style="text-align: left; width: 72%; padding-left: 0.625rem">
                Rate of Interest per Day
              </td>
              <td style="text-align: right; padding-right: 0.625rem">
                {{ sanctionLoanAmountObj?.sanction_ROI }}
              </td>
            </tr>
            <tr class="height-sanctionDetail">
              <td style="text-align: center; width: 11%">2</td>
              <td style="text-align: left; width: 72%; padding-left: 0.625rem">
                Tenure of the Loan (in days)
              </td>
              <td style="text-align: right; padding-right: 0.625rem">
                {{ sanctionLoanAmountObj?.sanction_LoanTenure }}
              </td>
            </tr>

            <tr class="height-sanctionDetail">
              <td style="text-align: center; width: 11%">3</td>
              <td style="text-align: left; width: 72%; padding-left: 0.625rem">
                Repayment Date
              </td>
              <td style="text-align: right; padding-right: 0.625rem">
                {{ sanctionLoanAmountObj?.RepaymentDate }}
              </td>
            </tr>

            <tr class="height-sanctionDetail">
              <td style="text-align: center; width: 11%">4</td>
              <td style="text-align: left; width: 72%; padding-left: 0.625rem">
                Repayment frequency by the borrower
              </td>
              <td style="text-align: right; padding-right: 0.625rem">One time</td>
            </tr>
            <tr class="height-sanctionDetail">
              <td style="text-align: center; width: 11%">5</td>
              <td style="text-align: left; width: 72%; padding-left: 0.625rem">
                Number of instalments of repayment
              </td>
              <td style="text-align: right; padding-right: 0.625rem">1</td>
            </tr>
            <tr class="height-sanctionDetail">
              <td style="text-align: center; width: 11%">6</td>
              <td style="text-align: left; width: 72%; padding-left: 0.625rem">
                Amount of each instalment of repayment (in Rupees)
              </td>
              <td style="text-align: right; padding-right: 0.625rem">
                {{ sanctionLoanAmountObj?.PaidByBorrower }}
              </td>
            </tr>
            <tr class="height-sanctionDetail">
              <td style="text-align: center; width: 11%">7</td>
              <td style="text-align: left; width: 72%; padding-left: 0.625rem">
                Annual Percentage Rate (APR) %
              </td>
              <td style="text-align: right; padding-right: 0.625rem">
                {{ applicationDetail?.APR }}
              </td>
            </tr>



          </tbody>
        </table>
      </div>

      <div id="sanctionDetailPrintKFS" style="display: none">
        <table style="font-size: 0.9375rem" class="MsoTableGrid" width="100%" border="1" cellspacing="0"
          cellpadding="0">
          <thead>
            <tr class="height-sanctionDetail" style="background-color: #acc8ee">
              <!--<th class="WD-66">Document Type</th>-->
              <th class="WD-66" style="padding-left: 0.625rem">Sr.No.</th>
              <th class="WD-66" style="padding-left: 0.625rem">Parameter</th>
              <th class="WD-66" style="padding-left: 0.625rem">Details</th>
            </tr>
          </thead>
          <tbody>
            <tr class="height-sanctionDetail">
              <td style="text-align: center; width: 11%">1</td>
              <td style="text-align: left; width: 72%; padding-left: 0.625rem">
                Loan Account No.
              </td>
              <td style="text-align: right; padding-right: 0.625rem">
                {{ applicationDetail?.Loan_No }}
              </td>
            </tr>
            <tr class="height-sanctionDetail">
              <td style="text-align: center; width: 11%">2</td>
              <td style="text-align: left; width: 72%; padding-left: 0.625rem">
                Type of Loan
              </td>
              <td style="text-align: right; padding-right: 0.625rem">
                Single EMI
              </td>
            </tr>

            <tr class="height-sanctionDetail">
              <td style="text-align: center; width: 11%">3</td>
              <td style="text-align: left; width: 72%; padding-left: 0.625rem">
                Loan Amount Sanctioned
              </td>
              <td style="text-align: right; padding-right: 0.625rem">
                {{ sanctionLoanAmountObj?.sanction_LoanAmount}}
              </td>
            </tr>

            <tr class="height-sanctionDetail">
              <td style="text-align: center; width: 11%">4</td>
              <td style="text-align: left; width: 72%; padding-left: 0.625rem">
                Disbursal Amount (after deduction of charges)
              </td>
              <td style="text-align: right; padding-right: 0.625rem">{{ sanctionLoanAmountObj?.NetDisbursementAmount }}
              </td>
            </tr>
            <tr class="height-sanctionDetail">
              <td style="text-align: center; width: 11%">5</td>
              <td style="text-align: left; width: 72%; padding-left: 0.625rem">
                Total Amount Payable by Borrower
              </td>
              <td style="text-align: right; padding-right: 0.625rem">{{ sanctionLoanAmountObj?.PaidByBorrower}}</td>
            </tr>
            <tr class="height-sanctionDetail">
              <td style="text-align: center; width: 11%">6</td>
              <td style="text-align: left; width: 72%; padding-left: 0.625rem">
                Annual Percentage Rate (APR)
              </td>
              <td style="text-align: right; padding-right: 0.625rem">
                {{ applicationDetail?.APR }}
              </td>
            </tr>
            <tr class="height-sanctionDetail">
              <td style="text-align: center; width: 11%">7</td>
              <td style="text-align: left; width: 72%; padding-left: 0.625rem">
                Rate of Interest (Daily)
              </td>
              <td style="text-align: right; padding-right: 0.625rem">
                {{ applicationDetail?.ROI }}
              </td>
            </tr>
            <tr class="height-sanctionDetail">
              <td style="text-align: center; width: 11%">8</td>
              <td style="text-align: left; width: 72%; padding-left: 0.625rem">
                Loan Tenure
              <td style="text-align: right; padding-right: 0.625rem">
                {{ applicationDetail?.Tenure_Month }}
              </td>
            </tr>
            <tr class="height-sanctionDetail">
              <td style="text-align: center; width: 11%">9</td>
              <td style="text-align: left; width: 72%; padding-left: 0.625rem">
                Repayment Date(s)
              <td style="text-align: right; padding-right: 0.625rem">
                {{ applicationDetail?.Expiry_Date }}
              </td>
            </tr>
            <tr class="height-sanctionDetail">
              <td style="text-align: center; width: 11%">10</td>
              <td style="text-align: left; width: 72%; padding-left: 0.625rem">
                Repayment Frequency
              <td style="text-align: right; padding-right: 0.625rem">
                Single EMI
              </td>
            </tr>
            <tr class="height-sanctionDetail">
              <td style="text-align: center">11</td>
              <td style="text-align: left; padding-left: 0.625rem">
                Deduction - Processing Fees &#64;
                {{ sanctionLoanAmountObj?.ProcessingFeePercentage }} %
              </td>
              <td style="text-align: right; padding-right: 0.625rem">
                {{ sanctionLoanAmountObj?.ProcessingFeeCharges }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>